import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const KEY = "td-recording-mode";

export default function RecordingMode() {
  const location = useLocation();
  useEffect(() => {
    const requested = new URLSearchParams(location.search).get("recording");
    if (requested === "1") sessionStorage.setItem(KEY, "1");
    if (requested === "0") sessionStorage.removeItem(KEY);
    document.body.classList.toggle("td-recording-mode", sessionStorage.getItem(KEY) === "1");
    return () => document.body.classList.remove("td-recording-mode");
  }, [location.search]);
  return null;
}
